export function ScoreDelta({
  current,
  previous,
  fractionDigits = 2,
}: {
  current: number;
  previous: number;
  fractionDigits?: number;
}) {
  const delta = current - previous;
  const isStable = Math.abs(delta) < 0.01;
  const deltaStyle = isStable
    ? "text-slate-500"
    : delta > 0
      ? "text-green-700"
      : "text-red-700";
  const deltaIcon = isStable ? "=" : delta > 0 ? "▲" : "▼";
  const signedDelta = `${delta > 0 ? "+" : ""}${delta.toFixed(fractionDigits)}`;

  return (
    <span
      className={`text-xs font-medium whitespace-nowrap ${deltaStyle}`}
      title={`Previous: ${previous.toFixed(fractionDigits)}`}
    >
      {isStable ? deltaIcon : `${deltaIcon} ${signedDelta}`}
    </span>
  );
}
